export const LOCALE_STORAGE_KEY = 'LOCALE';
export const DEVICE_FINGERPRINT_KEY = 'DEVICE_FINGERPRINT';
